import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http";
import { Chart } from 'react-google-charts';
import NoData from "../../NoData";
import ChartLoader from '../../ChartLoader';
import CommanBarTable_Kratos from "../CommanBarTable_Kratos";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_kratos';
import WaterMark from "../../DashboardMain_Kratos/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales,
  Ticks
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata
let res_result = []

let labelsForPopup = ["20", "40", "60", "80", "100", "120", "140", "160", "180", "180+"]

function GunConnectVehicles_Kratos({ apiend, gloablfilter, type, chartnameFCD }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState(chartnameFCD);
  let barcolor = "#83A4CF"

  const appyDataVehicles = (data) => {
    res_result = []
    res_result = data;
    let responce = {
      "<=20": 0,
      "40": 0,
      "60": 0,
      "80": 0,
      "100": 0,
      "120": 0,
      "140": 0,
      "160": 0,
      "180": 0,
      ">180": 0,
    };
    if (res_result.length !== 0) {
      let temp_result = res_result;
      let id = 0
      let newapiarray = []
      SetApiResponce(res_result)
      temp_result.map(d => {
        let value = d.gunDurationInMin.values["50.0"];
        if (value != null) {
          if (value > 0 && value <= 20) {
            responce["<=20"] = responce["<=20"] + 1;
          } else if (value > 20 && value <= 40) {
            responce["40"] = responce["40"] + 1;
          } else if (value > 40 && value <= 60) {
            responce["60"] = responce["60"] + 1;
          } else if (value > 60 && value <= 80) {
            responce["80"] = responce["80"] + 1;
          } else if (value > 80 && value <= 100) {
            responce["100"] = responce["100"] + 1;
          } else if (value > 100 && value <= 120) {
            responce["120"] = responce["120"] + 1;
          } else if (value > 120 && value <= 140) {
            responce["140"] = responce["140"] + 1;
          } else if (value > 140 && value <= 160) {
            responce["160"] = responce["160"] + 1;
          } else if (value > 160 && value <= 180) {
            responce["180"] = responce["180"] + 1;
          } else if (value > 180) {
            responce[">180"] = responce[">180"] + 1;
          }
        }
      })

      let res_result_final = [["Element", "Count", { role: "style" }]]
      const loop_keys = ["<=20", "40", "60", "80", "100", "120", "140", "160", "180", ">180"]
      let countcheck = 0
      for (const key in responce) {
        if (responce[key] > 0) {
          countcheck = countcheck + 1
        }
      }

      loop_keys.map(x => {
        if (countcheck)
          // "#83A4CF"
          res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
      })

      const labels = ["<=20", "40", "60", "80", "100", "120", "140", "160", "180", ">180"]
      Maxchartdata = {
        labels,
        datasets: [
          {
            label: "Time (minutes)",
            data: responce,
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },
        ]
      };
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }
  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Time (minutes)'
        },
        suggestedMin: 0,
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        }
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Vehicle Count'
        },
        suggestedMin: 0,
      },
    },

    plugins: {
      legend: {
        display: false
      },
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Time (minutes)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90,
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Vehicle Count',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#83A4CF" },
    },
  };

  useEffect(() => {
    barcolor = "#83A4CF"
    SetChartName(chartnameFCD);
    fetchData({ url: API_URL_MAIN + "kratos_charge/" + apiend, body: { filterdata: gloablfilter } }, appyDataVehicles)
  }, [gloablfilter, type])

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {
                (isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                  : <NoData />
                )}
            </div>
          </div>
        </div>
      </div>

      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>
      <WaterMark />

      {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="200px" data={chartdata} options={options} chartEvents={[
        {
          eventName: 'select',
          callback: ({ chartWrapper }) => {
            const chart = chartWrapper.getChart()
            const selection = chart.getSelection()
            if (selection.length === 1) {
              const [selectedItem] = selection;
              const { row } = selectedItem;

              // const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
              // const count = chartWrapper.getDataTable().Wf[row].c[1].v;

              // let filtered_temp = [];
              // if (count !== 0) {
              //   filtered_temp = apiresponce.filter(x => {
              //     if (x.gunDurationInMin.values["50.0"] <= barvalue && x.gunDurationInMin.values["50.0"] > barvalue - 20) {
              //       return x;
              //     }
              //     else if (x.gunDurationInMin.values["50.0"] > 180 && barvalue === ">180") {
              //       return x
              //     }
              //     else if (x.gunDurationInMin.values["50.0"] <= 20 && barvalue === "<=20") {
              //       return x
              //     }
              //   })

              //   function compareObjects(object1, object2, key) {
              //     let obj1 = 0
              //     let obj2 = 0
              //     obj1 = object1.gunDurationInMin.values["50.0"]
              //     obj2 = object2.gunDurationInMin.values["50.0"]
              //     if (obj1 > obj2) {
              //       return -1
              //     }
              //     if (obj1 < obj2) {
              //       return 1
              //     }
              //     return 0
              //   }

              //   filtered_temp.sort((value1, value2) => {
              //     return compareObjects(value1, value2, 'value')
              //   })

              let minRange = labelsForPopup[row - 1]
              let maxRange = labelsForPopup[row]

              const filteredData = apiresponce.filter((item) => {
                const value = Number(item?.gunDurationInMin?.values?.["50.0"]);

                if (row === 0) {
                  return value < Number(maxRange);
                }

                if (row === labelsForPopup.length - 1) {
                  return value > Number(minRange);
                }

                return value > Number(minRange) && value <= Number(maxRange);

              });
              SetfilteredData(prestate => filteredData);
              window.$('#exampleModal__' + apiend).modal('show');
            }
            // }
          }
        }
      ]}
      /> : <NoData />)}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
            <div className="modal-body">
              {/* <table className="table table-striped">
                <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                  <tr>
                    <th scope="col">Vin Number</th>
                    <th scope="col">Value</th>
                  </tr></thead>
                <tbody> */}
              <CommanBarTable_Kratos data={filteredData} tabDataKey={"gunDurationInMin"} />
              {/* </tbody></table> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GunConnectVehicles_Kratos;